import $ from "jquery";

const miniCart = () => {
  $(document).on("click", ".js-cart-icon", function (e) {
    e.preventDefault();
    $(".js-header-mini-cart").addClass("show");
    document.addEventListener("click", handleClose);
  });

  $(document).on("click", ".js-close-mini-cart", function (e) {
    e.preventDefault();
    $(".js-header-mini-cart").removeClass("show");
  });

  const handleClose = (e) => {
    if (
      !$(".js-header-mini-cart").is(e.target) &&
      $(".js-header-mini-cart").has(e.target).length === 0
    ) {
      $(".js-header-mini-cart").removeClass("show");
      removeEventListener();
    }
  };

  const removeEventListener = () => {
    document.removeEventListener("click", handleClose);
  };
};

try {
  miniCart();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
